import {useMutation, UseMutationResult} from '@tanstack/react-query';
import {useLocale} from 'state/locale';
import {request} from 'utils/request-axios';

import {PostcodeAutofill} from './types';
import {cleanPostcode} from './utils';

const useGetPostcodeAutoFill = (): UseMutationResult<
    PostcodeAutofill,
    Error,
    string
> => {
    const locale = useLocale();

    return useMutation({
        mutationFn: (postcode) =>
            request({
                locale,
                method: 'GET',
                url: `/api/address/zipcode/${cleanPostcode(postcode)}/`,
            }),
    });
};

export default useGetPostcodeAutoFill;
